import React, {useMemo, useState} from "react";
import Card from "../../../../components/Card";
import IconButton from "../../../../components/IconButton";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import {Media, MediaCategory, MediaWithCategories} from "../../../../types/Media";
import cx from 'classnames'
import styles from './MediaCard.module.scss'
import Image from "../../../../components/Image";
import Text from "../../../../components/Text";


const MediaCard: React.FC<MediaWithCategories & {
    openEditModal: (media: Media) => void
    openDeleteModal :(media :Media)=>void
    categories: MediaCategory[]
}> = ({ id, name, path, active, media_category_ids,openEditModal ,openDeleteModal, categories}) => {

    const mediaCategories = useMemo(() => {
        return categories.filter((c) => {
            const c_id = (typeof c.id === 'string') ? parseInt(c.id) : c.id
            return media_category_ids.includes(c_id)
        }).map((c) => {
            c.name = (c.name.length > 8)  ? c.name.substring(0, 8) + "..." : c.name
            return c
        })
    }, [categories])

    return (
        <Card classes={cx(styles['card-wrapper'])}>
            <div className={cx(styles['card-button-wrapper'])}>
                <IconButton icon={faEdit} color={'#2f2f2f'} onClick={() => openEditModal({ id, name, path, active })} />
                <IconButton icon={faTrashAlt} color={'#2f2f2f'} onClick={() => openDeleteModal({ id, name, path, active })} />
            </div>
            <div className={cx(styles['card-inner-wrapper'])}>
                <div className={cx(styles['media-wrapper'])}>
                    <Image src={path} alt={name} height={150} width={150} />
                    <Text>{name}</Text>
                    <div className={cx(styles['selected-categories'])}>
                        {mediaCategories.map((c) => {
                            return (
                                <div key={c.id} className={cx(styles['selected-categories-elements'])}>
                                    <span>{c.name}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Card>
    );
}

export default MediaCard;
